import { nanoIdSchema } from "../../shared/id.mjs";
import { taskOutputSchema } from "../output.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/task/preGeneration/acquire.ts
const acquirePreGenerationInputSchema = z.object({
	sceneId: z.string().min(1),
	tackId: nanoIdSchema.optional()
});
const acquirePreGenerationRoute = oc.route({
	summary: "Acquire a pre-generated task",
	description: "Claims a pre-generated task for the current user. Tackled by tackId on the new path; falls back to the legacy TAG pool while migration is in flight.",
	method: "POST",
	path: "/pre-generation/acquire"
}).input(acquirePreGenerationInputSchema).output(taskOutputSchema).errors({
	UNAUTHORIZED: {
		status: 401,
		message: "Authentication required"
	},
	NOT_FOUND: {
		status: 404,
		message: "No pre-generated task is available for this scene"
	}
});
//#endregion
export { acquirePreGenerationInputSchema, acquirePreGenerationRoute };
